/* Tooltip metodológico do campo Classificação — exibe as 7 definições V2. */
import { useState } from "react";
import { HelpCircle, X } from "lucide-react";
import { CLASSIFICACAO_DEFINICOES } from "@/lib/constants";

export default function ClassificacaoTooltip({ current }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center justify-center w-5 h-5 text-[var(--text-muted)] hover:text-[var(--gold)]"
        title="Ajuda metodológica das classificações"
        data-testid="classificacao-help-btn"
      >
        <HelpCircle size={14} />
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="classificacao-help-modal">
          <div className="card-mil p-5 max-w-2xl w-full max-h-[80vh] overflow-y-auto gold-accent-top" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-display font-bold text-lg">Classificação da Potencial Semente</h3>
              <button type="button" onClick={() => setOpen(false)} className="text-[var(--text-muted)] hover:text-[var(--text)]" data-testid="classificacao-help-close">
                <X size={18} />
              </button>
            </div>
            <p className="text-xs text-[var(--text-muted)] mb-4">
              Conforme Manual Metodológico V2 — LSC/EGN.
            </p>
            <div className="space-y-3">
              {Object.entries(CLASSIFICACAO_DEFINICOES).map(([key, def]) => (
                <div key={key} className={`border-l-4 pl-3 py-1 ${current === key ? "border-[var(--gold)] bg-[var(--gold)]/5" : "border-[var(--border)]"}`}>
                  <div className="flex items-center gap-2">
                    <span className="font-mono text-[10px] px-1.5 py-0.5 border border-[var(--border)] rounded">{key}</span>
                    <span className="font-display font-bold text-sm">{def.titulo}</span>
                  </div>
                  <p className="text-xs text-[var(--text-muted)] mt-1">{def.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
